import React, { forwardRef, useState } from "react";

type Props = React.InputHTMLAttributes<HTMLInputElement>;

const formatCpfCnpj = (value: string) => {
  const onlyDigits = value.replace(/\D/g, "");

  if (onlyDigits.length <= 11) {
    return onlyDigits
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d{1,2})$/, "$1-$2");
  } else {
    return onlyDigits
      .replace(/(\d{2})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d)/, "$1/$2")
      .replace(/(\d{4})(\d{1,2})$/, "$1-$2");
  }
};

export const MaskedInputCpfCnpj = forwardRef<HTMLInputElement, Props>(
  ({ onChange, ...props }, ref) => {
    const [value, setValue] = useState(props.value);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      const raw = e.target.value;
      const masked = formatCpfCnpj(raw);
      setValue(masked);

      const syntheticEvent = {
        ...e,
        target: {
          ...e.target,
          value: masked,
        },
      };

      onChange?.(syntheticEvent as React.ChangeEvent<HTMLInputElement>);
    };

    return (
      <input
        {...props}
        ref={ref}
        value={value}
        onChange={handleChange}
        maxLength={18}
        inputMode="numeric"
        // pattern="\\d*"
      />
    );
  }
);

MaskedInputCpfCnpj.displayName = "MaskedInputCpfCnpj";
